import type { FormLayout } from '@/screens/ReportCreation/reportCreation.types';
import { YStack } from 'tamagui';
import { FormSectionList } from './FormSectionList';
import { RepeatableSectionContainer } from './RepeatableSectionContainer';

/**
 * High-level renderer that composes static sections and repeatable blocks.
 * Each repeatable block reuses the same declarative section definitions
 */
export const FormRenderer = ({
  sections = [],
  repeatableSections = [],
}: FormLayout): React.ReactElement => (
  <YStack gap="$5">
    <FormSectionList sections={sections} />
    {repeatableSections?.map((repeatableSection) => (
      <RepeatableSectionContainer
        key={repeatableSection.id}
        config={repeatableSection}
      />
    ))}
  </YStack>
);
